import { asyncComponent } from 'utils';

const dynamicImportFillInfo = () => import(/* webpackChunkName: "Account-fillInfo" */ './index');

export default dynamicImportFillInfo;

export const AsyncFillInfo = asyncComponent(dynamicImportFillInfo);
